import { Routes, Route } from "react-router-dom";
import Layout from "./components/layouts/Layout";
import Homepage from "./pages/homepage";
import LubewatchForm from "./pages/lubewatchForm";
import NotfoundPage from "./pages/NotfoundPage";

const App = () => {
    return (
        <Layout>
            <Routes>
                <Route exact path="/" element={<Homepage />} />
                <Route path="/:formName" element={<LubewatchForm />} />
                <Route path="*" exact={true} element={<NotfoundPage />} />
            </Routes>
        </Layout>
    );
};

export default App;
